import {Component, Input} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@Component({
    selector: 'app-adx-booking-markup-info',
    templateUrl: './adx-booking-markup-info.component.html',
    standalone: false
})
@AutoUnsubscribe()
export class AdxBookingMarkupInfoComponent {
  @Input() data: any;
  get markupExtension(): any {
    return this.data ?? {};
  }
  get markupTypeMetadata(): any {
    return this.markupExtension?.markupTypeMetadata ?? {};
  }
}
